import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-c5650f10")

_pushScopeId("data-v-c5650f10")
const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "PaymentMethod__title" }, "Выберите способ оплаты", -1)
const _hoisted_2 = { class: "PaymentMethod__options" }
const _hoisted_3 = /*#__PURE__*/_createVNode("svg", {
  width: "14",
  height: "14",
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createVNode("circle", {
    class: "option__circle",
    cx: "7",
    cy: "7",
    r: "5",
    fill: "currentColor"
  }),
  /*#__PURE__*/_createVNode("circle", {
    class: "option__border",
    cx: "7",
    cy: "7",
    r: "6.5",
    stroke: "currentColor"
  })
], -1)
const _hoisted_4 = { class: "option__name" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    class: ["PaymentMethod", { disabled: _ctx.disabled }]
  }, [
    _hoisted_1,
    _createVNode("div", _hoisted_2, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.paymentOptions, (payment_method) => {
        return (_openBlock(), _createBlock("div", {
          key: payment_method.id,
          class: ["options__option", {
                    'option--selected': _ctx.isOptionSelected(payment_method),
                    'option--disabled': _ctx.isOptionDisabled(payment_method),
                }],
          onClick: ($event: any) => (_ctx.onOptionSelect(payment_method))
        }, [
          _hoisted_3,
          _createVNode("div", _hoisted_4, _toDisplayString(payment_method.name), 1)
        ], 10, ["onClick"]))
      }), 128))
    ])
  ], 2))
})